import Vue from 'vue'
import Vuex from 'vuex'

import Network from '../vue-components/helpers/Network'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        loginStatus: ``,
        language: null,
        initialLoading: true,
        applicationReady: false,
        webpSupport: true,
        shopifyClient: null
    },
    getters: {
        language(state) {
            if (!state.language) {
                let language = localStorage.getItem(`language`);
                if (!language) {
                    language = navigator.language.substring(0, 2) === `fr` ? `fr` : `en`;
                }
                localStorage.setItem(`language`, language);
                state.language = language;
            }
            return state.language;
        },
        currentUser(state) {
            if (state.user) {
                return state.user;
            } else {
                return null;
            }
        },
        isAuthenticated(state) {
            return !!state.user;
        },
        fullName(state) {
            if (state.user)
                return state.user.first_name + ` ` + state.user.last_name;
            else
                return ``;
        }
    },
    mutations: {
        startLogin(state) {
            state.loginStatus = `loading`
        },
        authSuccess(state, user) {
            state.loginStatus = `success`;
            state.user = user;
        },
        notConnected(state, user) {
            state.loginStatus = `not_connected`;
        },
        authError(state) {
            state.loginStatus = `error`
        },
        loggedOut(state) {
            state.loginStatus = `logged_out`;
            state.user = null;
        },
        setUsers(state, users) {
            state.users = users;
        },
        setLanguage(state, language) {
            state.language = language;
            localStorage.setItem(`language`, language);
        },
        setWebpSupport(state) {
            const canvas = typeof document === `object`
            ? document.createElement(`canvas`) : {};
            canvas.width = canvas.height = 1;
            state.webpSupport = canvas.toDataURL ? canvas.toDataURL(`image/webp`).indexOf(`image/webp`) === 5 : false;
        },
        changeLanguage(state) {
            let language = localStorage.getItem(`language`);
            if (language === `fr`) {
                language = `en`;
            } else {
                language = `fr`;
            }

            localStorage.setItem(`language`, language);
            state.language = language;
            return language;
        }
    },
    actions: {
        getCurrentUser({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                commit(`startLogin`);
                const token = localStorage.getItem(`token`);

                if (token) {
                    Network.setToken(token);

                    Network.get(`/loyalty/user/current-user`)
                        .then(response => {
                            const user = response.data;
                            if (user) {
                                commit(`authSuccess`, user);
                                resolve();
                            }
                        })
                        .catch(err => {
                            commit(`authError`, err);
                            localStorage.removeItem(`token`);
                            Network.removeToken();
                            reject(err);
                        });
                } else {
                    commit(`notConnected`);
                    resolve();
                }
            });
        },
        login({commit, dispatch}, postData) {
            return new Promise((resolve, reject) => {
                commit(`startLogin`);
                Network.post(`/loyalty/user/login`, postData)
                    .then(response => {
                        const user = response.data;
                        localStorage.setItem(`token`, user.token);
                        Network.setToken(user.token);
                        commit(`authSuccess`, user);
                        resolve(user);
                    })
                    .catch(err => {
                        commit(`authError`, err);
                        localStorage.removeItem(`token`);
                        Network.removeToken();
                        reject(err);
                    });
            });
        },
        logout({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                commit(`loggedOut`);
                localStorage.removeItem(`token`);
                Network.removeToken();
                resolve();
            });
        }
    }
})
